/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_CtaInputs */

const en_simple_mulai_cta = /** @type {(inputs: Simple_Mulai_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start now`)
};

const id_simple_mulai_cta = /** @type {(inputs: Simple_Mulai_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai sekarang`)
};

/**
* | output |
* | --- |
* | "Start now" |
*
* @param {Simple_Mulai_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_cta = /** @type {((inputs?: Simple_Mulai_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_cta(inputs)
	return en_simple_mulai_cta(inputs)
});